<template>
    <b-modal id="SendConfigModal" size="lg" hide-footer hide-header @show="loadConfig">
        <div class="sc-header">
            <span>CONFIGURAÇÃO DE ENVIO</span>
            <span class="sc-close" @click="$bvModal.hide('SendConfigModal')">✕</span>
        </div>

        <div class="sc-body">
            <div class="sc-row-mode">
                <span class="sc-label">Modo de envio:</span>
                <label class="sc-radio">
                    <input type="radio" v-model="sendMode" value="manual" /> Manual
                </label>
                <label class="sc-radio" style="margin-left: 14px;">
                    <input type="radio" v-model="sendMode" value="automatico" /> Automático
                </label>
            </div>

            <div class="sc-info-box">
                <b>Configuração de Destinatários</b>
                <p>Selecione até 5 usuários para receber o relatório PDF. O envio ocorre {{ sendMode === 'automatico' ? 'automaticamente ao fechar o turno' : 'manualmente via botão na toolbar' }}.</p>
            </div>

            <div v-if="loadingUsers" class="sc-loading">Carregando usuários...</div>
            <div v-else>
                <div v-for="user in availableUsers" :key="user.id"
                    class="sc-user-row"
                    :class="{ 'sc-user-selected': isSelected(user.id) }">
                    <div class="sc-user-info">
                        <input type="checkbox"
                            :checked="isSelected(user.id)"
                            @change="toggleUser(user)"
                            :disabled="!isSelected(user.id) && selectedCount >= 5" />
                        <span class="sc-user-name">{{ user.name }}</span>
                    </div>
                    <input v-if="isSelected(user.id)"
                        type="text"
                        class="sc-phone-input"
                        v-model="userPhones[user.id]"
                        placeholder="DDD + número (11 dígitos)"
                        maxlength="11"
                        @keypress="onlyNumbers($event)" />
                </div>
            </div>
        </div>

        <div class="sc-footer">
            <button class="sc-btn-cancel" @click="$bvModal.hide('SendConfigModal')">CANCELAR</button>
            <button class="sc-btn-save" @click="save">SALVAR</button>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios';
import { urlMainAPI } from '../../../global.js';

export default {
    name: 'SendConfigModal',
    props: {
        initialSendMode: { type: String, default: 'manual' }
    },
    data() {
        return {
            sendMode: 'manual',
            availableUsers: [],
            selectedUserIds: [],
            userPhones: {},
            loadingUsers: false
        };
    },
    computed: {
        selectedCount() {
            return this.selectedUserIds.length;
        }
    },
    methods: {
        async loadConfig() {
            this.sendMode = this.initialSendMode || 'manual';
            this.loadingUsers = true;
            try {
                const [usersRes, waRes] = await Promise.all([
                    axios.get(`${urlMainAPI}/getusers`),
                    axios.get(`${urlMainAPI}/getwhatsappusers`)
                ]);
                this.availableUsers = (usersRes.data || []).sort((a, b) =>
                    a.name.localeCompare(b.name, 'pt-BR')
                );
                const waUsers = waRes.data || [];
                this.selectedUserIds = waUsers.filter(u => u.isActive).map(u => u.userId);
                const phones = {};
                waUsers.forEach(u => {
                    phones[u.userId] = u.whatsAppNumber || '';
                });
                this.userPhones = phones;
            } catch {
                this.availableUsers = [];
            } finally {
                this.loadingUsers = false;
            }
        },
        isSelected(userId) {
            return this.selectedUserIds.includes(userId);
        },
        toggleUser(user) {
            const idx = this.selectedUserIds.indexOf(user.id);
            if (idx >= 0) {
                this.selectedUserIds.splice(idx, 1);
            } else if (this.selectedUserIds.length < 5) {
                this.selectedUserIds.push(user.id);
                if (!this.userPhones[user.id]) this.$set(this.userPhones, user.id, '');
            }
        },
        onlyNumbers(e) {
            if (!/[0-9]/.test(e.key)) e.preventDefault();
        },
        async save() {
            const waUsers = this.availableUsers.map(u => ({
                userId: u.id,
                whatsAppNumber: this.userPhones[u.id] || '',
                isActive: this.isSelected(u.id)
            }));
            try {
                await axios.post(`${urlMainAPI}/savewhatsappusers`, waUsers);
                await axios.post(`${urlMainAPI}/savereportsendconfig`, {
                    sendMode: this.sendMode
                });
                this.$emit('saved', { sendMode: this.sendMode });
                this.$bvModal.hide('SendConfigModal');
            } catch {
                // erro silencioso — toast no pai
            }
        }
    }
};
</script>

<style scoped>
.sc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px;
    border-bottom: 1px solid #eee;
    font-weight: bold;
    font-size: 13px;
    color: #333;
    text-transform: uppercase;
}
.sc-close { cursor: pointer; color: #999; font-size: 16px; }
.sc-body { padding: 20px 22px; display: flex; flex-direction: column; gap: 16px; }
.sc-row-mode { display: flex; align-items: center; gap: 10px; font-size: 14px; }
.sc-label { font-weight: bold; color: #333; }
.sc-radio { display: flex; align-items: center; gap: 5px; cursor: pointer; font-size: 14px; }
.sc-info-box {
    background: #f0faf9;
    border: 1px solid #1fb5ad;
    border-radius: 4px;
    padding: 12px 14px;
    font-size: 12px;
    color: #444;
}
.sc-info-box b { color: #1fb5ad; display: block; margin-bottom: 4px; }
.sc-info-box p { margin: 0; }
.sc-user-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 6px;
}
.sc-user-selected { border-color: #1fb5ad; }
.sc-user-info { display: flex; align-items: center; gap: 10px; }
.sc-user-name { font-size: 13px; color: #333; }
.sc-phone-input {
    border: 1px solid #1fb5ad;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: 12px;
    width: 200px;
    outline: none;
}
.sc-loading { text-align: center; color: #999; font-style: italic; padding: 20px; }
.sc-footer {
    padding: 12px 18px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
.sc-btn-cancel {
    background: #fff;
    color: #f37021;
    border: 1px solid #f37021;
    padding: 8px 22px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: 12px;
    text-transform: uppercase;
}
.sc-btn-save {
    background: #f37021;
    color: #fff;
    border: none;
    padding: 8px 22px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    font-size: 12px;
    text-transform: uppercase;
}
</style>
